import { useRef } from 'react';

import { FinalisePayrunModal } from './modal/finalise-payrun-modal';
import { FinalisePayrunProps, ModalDialogRef } from './finalise-payrun.types';
import { FinalisePayrunButton } from './finalise-payrun-button';

export function FinalisePayrun({
  payrunId,
  renderButton,
  onSuccess,
}: Readonly<FinalisePayrunProps>) {
  const modalRef = useRef<ModalDialogRef>(null);

  const handleOpenModal = () => {
    modalRef.current?.openModalDialog();
  };

  if (!payrunId) return null;

  return (
    <>
      <FinalisePayrunButton onClick={handleOpenModal} renderButton={renderButton} />

      <FinalisePayrunModal ref={modalRef} payrunId={payrunId} onSuccess={onSuccess} />
    </>
  );
}

export default FinalisePayrun;
